import { render, staticRenderFns } from "./comHome2.vue?vue&type=template&id=793f9508&scoped=true&"
import script from "./comHome2.vue?vue&type=script&lang=js&"
export * from "./comHome2.vue?vue&type=script&lang=js&"
import style0 from "./comHome2.vue?vue&type=style&index=0&id=793f9508&scoped=true&lang=css&"
import style1 from "./comHome2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793f9508",
  null
  
)

export default component.exports